import React from "react";
import "./button.css"; // Import styles
import Spinner from 'react-bootstrap/Spinner';
const Button = ({ size = "medium", label, onClick, loading, className, icon, type = "button" }) => {
  return (
    <button
      type={type}
      className={`${className} cmn_btn btn-${size} ${(loading === true || icon) && "d-flex gap-2 align-items-center justify-content-center"}`}
      onClick={onClick}
    >
      {icon && icon}  {label} {loading && <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>}
    </button>
  );
};

export default Button;
